import { render, staticRenderFns } from "./ClientSettingDialog.vue?vue&type=template&id=cff89548&scoped=true&"
import script from "./ClientSettingDialog.vue?vue&type=script&lang=js&"
export * from "./ClientSettingDialog.vue?vue&type=script&lang=js&"
import style0 from "./ClientSettingDialog.vue?vue&type=style&index=0&id=cff89548&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff89548",
  null
  
)

component.options.__file = "ClientSettingDialog.vue"
export default component.exports